module.exports = __webpack_public_path__ + "static/media/carif.f2aa9e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/carif.png
// module id = 458
// module chunks = 0